export class SingletonLoader {
  private promise?: Promise<unknown>;

  async load<Args, Result>(fn: (args: Args) => Promise<Result>, args: Args, options: { cacheTime?: number } = { cacheTime: 10000 }): Promise<Result> {
    if (this.promise) return (await this.promise) as Result;

    this.promise = fn(args)
      .then((result) => {
        // Don't cache undefined/null results - treat as failure
        if (result === undefined || result === null) {
          this.promise = undefined;
          return result;
        }
        // Schedule cleanup after cache time
        setTimeout(() => {
          this.promise = undefined;
        }, options.cacheTime);
        return result;
      })
      .catch((error) => {
        // On error, immediately clear the promise so retries can work
        this.promise = undefined;
        throw error;
      });

    return (await this.promise) as Result;
  }
}
